module.exports = __webpack_public_path__ + "static/media/2DGACM12.56493480.jpg";